import { render, staticRenderFns } from "./Bowtie.vue?vue&type=template&id=86f12c46&"
import script from "./Bowtie.vue?vue&type=script&lang=js&"
export * from "./Bowtie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports